// ═══════════════════════════════════════════════════════════════════════════════
// CART OBSERVER — universal hook for every Shopify cart mutation
// ═══════════════════════════════════════════════════════════════════════════════
//
// Wraps window.fetch and XMLHttpRequest so that any request to
// /cart/(add|change|update|clear) — regardless of origin (theme code, third-party
// app, Buy Button SDK, raw console fetch) — fires a `cart:changed` DOM event on
// success. See docs/cart-observer.md for the full rationale.
//
// MUST load BEFORE ajax-cart.js and must NOT be deferred — the wrappers have to
// be in place before any other script touches window.fetch.
// ═══════════════════════════════════════════════════════════════════════════════

(function () {
  if (window.__cartObserverInstalled) return;
  window.__cartObserverInstalled = true;

  // Matches /cart/add, /cart/add.js, /en/cart/change.js, /cart/update?…, /cart/clear.js
  var CART_MUTATION = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/i;

  // ── Wrap fetch ─────────────────────────────────────────────────────────────
  var originalFetch = window.fetch.bind(window);
  window.fetch = async function (input, init) {
    var url =
      typeof input === 'string'
        ? input
        : input instanceof Request
          ? input.url
          : (input && input.url) || '';

    var isCartMutation = CART_MUTATION.test(url);
    var response;
    try {
      response = await originalFetch(input, init);
    } catch (err) {
      if (isCartMutation) emit('cart:error', { url: url, error: err });
      throw err;
    }

    if (isCartMutation && response.ok) {
      // Clone so the caller can still read the body.
      emit('cart:changed', {
        url: url,
        endpoint: detectEndpoint(url),
        response: response.clone()
      });
    }
    return response;
  };

  // ── Wrap XMLHttpRequest ────────────────────────────────────────────────────
  var OrigOpen = XMLHttpRequest.prototype.open;
  var OrigSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url) {
    this.__cartUrl = String(url || '');
    return OrigOpen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function () {
    var xhr = this;
    if (CART_MUTATION.test(xhr.__cartUrl || '')) {
      xhr.addEventListener('load', function () {
        if (xhr.status >= 200 && xhr.status < 300) {
          emit('cart:changed', {
            url: xhr.__cartUrl,
            endpoint: detectEndpoint(xhr.__cartUrl),
            xhr: xhr
          });
        }
      });
      xhr.addEventListener('error', function () {
        emit('cart:error', { url: xhr.__cartUrl });
      });
    }
    return OrigSend.apply(xhr, arguments);
  };

  // ── Helpers ────────────────────────────────────────────────────────────────
  function detectEndpoint(url) {
    var m = url.match(/\/cart\/(add|change|update|clear)/i);
    return m ? m[1].toLowerCase() : 'unknown';
  }

  function emit(name, detail) {
    document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: detail }));
  }
})();
